// removed by extract-text-webpack-plugin
module.exports = {"ModalBackground":"ModalBackground--1-bkm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.local.css
// module id = 968
// module chunks = 1